<mat-nav-list class="item-list">
  <div (click)="itemsType==='REMOTE' && !item.online ? '' : itemSelected.emit(item)" *ngFor="let item of itemList | itemFilter: search" class="item-item">
    <div class="left-wrapper">
      <div class="icon-wrapper">
        <mat-icon *ngIf="itemsType==='RESORT'">store</mat-icon>
        <mat-icon *ngIf="itemsType==='REMOTE' && item.online" class="online_icon">cloud_on</mat-icon>
        <mat-icon *ngIf="itemsType==='REMOTE' && !item.online" class="offline_icon">cloud_off</mat-icon>
      </div>
      <span *ngIf="itemsType==='REMOTE'" class="dot" [ngClass]="{'online':item.online == true, 'offline': item.online == false}"></span>
      <span>{{ item.name }}</span>
    </div>
    <mat-icon *ngIf="itemsType==='RESORT' || (itemsType==='REMOTE' && item.online)">chevron_right</mat-icon>
  </div>
</mat-nav-list>
